import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { ConsultaMateriasApl, AddNotaApl, EliminarDatHistoricoApl, ConsultLiterales } from "../../../funciones/HistoricoFunction";
import { ConsultPeriodos } from '../../../funciones/OfertaFunction';

import CustomModal from "../../../components/Modal/CustomModal";

let idMat = "";
let nameMat = "";

class EditHistoricoAddMat extends Component {

    state = {
        valorMa: { value: '', label: '- Materia -' },
        MaDisp: [],
        notaSelect: { value: '', label: '- Nota -' },
        literales: [],
        boton1: "fa fa-save",
        boton2: "fa fa-trash-o",
        valorTe: { value: '', label: '- Tipo de Evaluación -' },
        TeDisp: [{ value: '', label: '- Cargando -' }],
        periodoSelect: {value:"", label: "- Selecciona un Periodo -"},
        periodos: [],
        matAplaz: [],
        preloader:{
            icon: "fa fa-spinner fa-spin",
            text: "Buscando Materias"
        },
        periodo: "",
        nota: "",
        notaDisabled: false,
        openDelMat: false,
        botonSi: <span>Si</span>,
        preloadNota: "",
    }

    constructor (props) {
        super(props)
        ConsultaMateriasApl(this.props.est.id, this.props.datSemestre.SemestreId, (resp) => {
            let respPre = "";
            if (resp[2] === 0) respPre= {
                icon: "",
                text: "No existen materias reprobadas para este estudiante en este periodo"
            }

            let cualit = 0
            for (let i in resp[0]) {
                if ((resp[0][i].cuantitativo) === 0) cualit ++;
            }

            if (cualit > 0) ConsultLiterales ((resp) => {
                this.setState({
                    literales: resp,
                })
            })

            this.setState({
                MaDisp: resp[0],
                TeDisp: resp[1],
                matAplaz: resp[2],
                preloader: respPre
            })
        })

        ConsultPeriodos((resp) => {
            this.setState({
                periodos: resp
            })
        })
    }

    valorPeriodo = (periodoSelect) => { this.setState({periodoSelect}) }
    valorNota = (notaSelect) => { this.setState({notaSelect}) }


    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: e.target.value,
            openDelMat: false
        })
    }

    te = () => {
        let { valorTe, TeDisp } = this.state;

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        return (
            <Select
                styles={{menu: customStyles}}
                title = "Selecciona un Tipo de Evaluación"
                isSearchable ={true}
                value={valorTe}
                onChange={this.valorSelectTe}
                options={ TeDisp }
            />
        )
    }

    valorSelectMa = (valorMa) => {
        this.setState({
            preloadNota: "fa fa-spinner fa-spin",
            openDelMat: false,
            notaDisabled: true
        }, () => {
            if (valorMa.cuantitativo === 0){
                ConsultLiterales ((resp) => {
                    this.setState({
                        preloadNota: "",
                        literales: resp,
                        valorMa,
                        openDelMat: false,    
                    })
                })
            }else{
                this.setState({
                    preloadNota: "",
                    valorMa,
                    openDelMat: false,
                    notaDisabled: false
                });
            } 
        })
    }

    valorSelectTe = (valorTe) => {
        this.setState({
            valorTe,
            openDelMat: false
        });
    }

    openModalDel = (id, name) => (e) => {
        idMat = id;
        nameMat = name;
        this.setState({openDelMat: true})
    }

    modalDelMat = () => {
        let { botonSi, openDelMat } = this.state;

        let contenidoModal = <div>
            ¿Desea realmente <strong>eliminar la asignatura <span className="text-danger">{nameMat}</span></strong> del archivo histórico del Estudiante?
            <div style={{fontSize:10}}>Esta opción no puede deshacerse</div>
        </div>

        return (
            <CustomModal
                backgroundColor= {"#1f2f6e"}
                isopen =  {openDelMat}
                titulo = {<div style={{color:"#FFF"}}>Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {botonSi}
                boton2 = "No"
                funcion1 = { () => {
                    this.setState({
                        botonSi: <span><i className="fa fa-spinner fa-spin"></i> Espera</span>
                    }, () => {
                        EliminarDatHistoricoApl (idMat, () => {
                            idMat = "";
                            this.setState({
                                openDelMat: false,
                                botonSi: <span>Si</span>,
                            }, () => {
                                toast.info("Se ha eliminado correctamente el registro histórico de la asignatura de este estudiante",{autoClose: 4000});
                                ConsultaMateriasApl(this.props.est.id, this.props.datSemestre.SemestreId, (resp) => {
                                    let respPre = "";
                                    if (resp[2] === 0) respPre = {
                                        icon: "",
                                        text: "No existen materias reprobadas para este estudiante en este periodo"
                                    }
                                    this.setState({
                                        MaDisp: resp[0],
                                        matAplaz: resp[2],
                                    })
                                })
                            })
                        })
                    })
                }
            }
            />
        )
    }

    materias = () => {
        let { matAplaz, preloader, boton2 } = this.state;

        if (matAplaz.length === 0) return (
            <tr>
                <td colSpan={7} align="center"><i className={preloader.icon}></i> {preloader.text}</td>
            </tr>
        )

        const styles = {
            minHeight: 40,
            fontSize: 10,
        }

        let enLetras = (nota) => {
            let letras = [
                "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                "DIECINUEVE", "VEINTE"
            ];
    
           return letras[nota - 1]
        }

        let mes = (num) => {
            let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
        
            return meses[num - 1]
        }

        let matNota = (tipo, nota) => {
            switch (tipo) {
                case 0:
                    let literalN = (lit) => {
                        if (lit === undefined) return <i className="fa fa-spinner fa-spin"></i>;
                        return lit.label
                    }
                    
                    return (
                        <td align="center" colSpan={2} style={styles}>{literalN(this.state.literales[parseInt(nota) - 1])}</td>
                    )
                case 1:
                    return (
                        <React.Fragment>
                            <td align="center" style={styles}>{nota}</td>
                            <td align="center" style={styles}>{enLetras(nota)}</td>
                        </React.Fragment>
                    )
                default: break;
            }
        }

        let contentTable = []

        for (let i in matAplaz) {
            

            if (matAplaz[i][0].length === 1) {
                let option = matAplaz[i][0][0]

                contentTable.push(
                    <tr key={option.id}>
                        <td align="center" style={styles}>{option.codigo}</td>
                        <td style={styles}>{option.materia_name}</td>
                        <td align="center" style={styles}>{`${mes(option.corte_name)} ${option.corte_year}`}</td>
                        <td align="center" style={styles}>{option.tipoev_name}</td>

                        { matNota(matAplaz[i][0][0].cuantitativo, option.nota) }

                        <td align="center">
                            <i className={`${boton2} text-danger`} onClick={this.openModalDel(option.id, option.materia_name)} style={{fontSize: 16, cursor: "pointer"}} title="Eliminar este histórico"></i>
                        </td>
                    </tr>
                )
            }else{
                let matMultiple = matAplaz[i][0]
                for (let n in matMultiple) {
                    let option = matMultiple[n]

                    contentTable.push(
                        <tr key={option.id}>
                            <td align="center" style={styles}>{option.codigo}</td>
                            <td style={styles}>{option.materia_name}</td>
                            <td align="center" style={styles}>{`${mes(option.corte_name)} ${option.corte_year}`}</td>
                            <td align="center" style={styles}>{option.tipoev_name}</td>
                            
                            { matNota(matMultiple[n].cuantitativo, option.nota) }
                            
                            <td align="center" style={styles}>
                                <i className={`${boton2} text-danger`} onClick={this.openModalDel(option.id, option.materia_name)} style={{fontSize: 16, cursor: "pointer"}} title="Eliminar este histórico"></i>
                            </td>
                        </tr>
                    )
                }
            }
        }

        return contentTable;
    }

    updateList = (resp) => {
        if (resp === "error") return null;

        this.setState({
            valorMa: { value: '', label: '- Materia -' },
            valorTe: { value: '', label: '- Tipo de Evaluación -' },
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Buscando Materias"
            },
            periodo: "",
            nota: "",
            openDelMat: false
        }, () => {
            ConsultaMateriasApl(this.props.est.id, this.props.datSemestre.SemestreId, (resp) => {
                let respPre = "";
                if ( resp[2] === 0) respPre= {
                    icon: "",
                    text: "No existen materias reprobadas para este estudiante en este periodo"
                }
                this.setState({
                    MaDisp: resp[0],
                    TeDisp: resp[1],
                    matAplaz: resp[2],
                    preloader: respPre
                })
            })
        })
    }

    render() {
        let { valorTe, valorMa, MaDisp, boton1, nota, periodoSelect, periodos, literales, notaSelect, preloadNota,
            notaDisabled, } = this.state;
        let { est } = this.props;

        const styles = {
            padding: 5, fontSize: 10
        }

        let MainAyuda = (
            <Popover style={{overflowY:"auto", height:"70vh", overflowX:"hidden"}} title={<React.Fragment><i className="fa fa-question-circle-o"></i> <strong>Agregar Datos Históricos</strong></React.Fragment>} id="hist">
                <div align="justify">
                    En esta sección podrás agregaro eliminar las asignaturas aplazadas correspondientes al semestre que has seleccionado.
                </div>
                <div className="custom-color custom-mt-10"><strong>Agregar Histórico</strong></div>
                <div align="justify">
                    Para agregar una nueva calificación al archivo histórico del estudiante primero debes seleccionar la Materia de las disponibles (En esta sección solo están disponibles las materias aplazadas).
                </div>
                <div className="custom-mt-10" align="justify">
                    Luego selecciona el periodo, el tipo de evaluación y la nota para la asignatura y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}>
                        <i className="fa fa-save"></i>
                    </button>
                </div>
                <div className="custom-color custom-mt-10"><strong>Listado de Asignaturas</strong></div>
                <div align="justify">
                    Aqui verás el listado histórico de asignaturas aplazadas del estudiante.
                </div>
                <Row className="custom-mt-10">
                    <Col md={3} align="center">
                        <i className="fa fa-trash-o text-danger" style={{fontSize:18}}></i>
                    </Col>
                    <Col md={9} align="justify">
                        Este botón permite eliminar el registro histórico del estudiante de forma individual.
                    </Col>
                </Row>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        let notaIn = () => {
            switch (valorMa.cuantitativo) {
                case 0:
                    return (
                        <React.Fragment>
                            <Select
                                styles={{menu: customStyles}}
                                isSearchable ={true}
                                value={notaSelect}
                                onChange={this.valorNota}
                                options={literales}
                            />
                            <div className="text-muted" style={{fontSize: 10}}>Nota</div>
                        </React.Fragment>
                    )
                case 1:
                    return (
                        <React.Fragment>
                            <input className="form-control" disabled={notaDisabled} value={nota} onChange={this.cambiaValor("nota")}/>
                            <div className="text-muted" style={{fontSize: 10}}>Nota</div>
                        </React.Fragment>
                    )
                default: return null;
            }
        }

        return (
            <div>
                <Row>
                    <Col md={10}>
                        <div className="custom-alert-success">Datos del Estudiante</div>
                        <Row style={{padding: 10}}>
                            <Col md={7}>
                                <span className="text-danger" style={{fontSize:10}}>Nombres y Apellido: </span>
                                <span className="text-muted" style={{fontSize:10}}>{est.nombre}</span>
                            </Col>
                            <Col md={5} align="right">
                                <span className="text-danger" style={{fontSize:10}}>Cédula de Identidad: </span>
                                <span className="text-muted" style={{fontSize:10}}>{est.ci}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} align="right">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={ MainAyuda }>
                            <button className="btn btn-warning" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>

                <div className="custom-alert-warning custom-mt-10">Materias no Aprobadas <i className={preloadNota}></i></div>
                <Row className="custom-mt-10">
                    <Col md={3}>
                        <Select
                            styles={{menu: customStyles}}
                            title = "Selecciona una Materia"
                            isSearchable ={true}
                            value={valorMa}
                            onChange={this.valorSelectMa}
                            options={ MaDisp }
                        />
                        <div className="text-muted" style={{fontSize: 10}}>Selecciona una Materia</div>
                    </Col>
                    <Col md={2} title="Selecciona un Periodo">
                        <Select
                            styles={{menu: customStyles}}
                            isSearchable ={true}
                            value={periodoSelect}
                            onChange={this.valorPeriodo}
                            options={periodos}
                        />
                        <div className="text-muted" style={{fontSize: 10}}>Periodo</div>
                    </Col>
                    <Col md={3}>
                        {this.te()}
                        <div className="text-muted" style={{fontSize: 10}}>Selecciona un Tipo de Evaluación</div>
                    </Col>
                    <Col md={2}>
                        {notaIn()}
                    </Col>
                    <Col md={2} align="right" style={{marginTop: 5}}>
                        <button className="btn btn-primary" style={{borderWidth: 1}} title="Añadir nueva calificación" onClick={
                            () => {
                                this.setState({
                                    boton1: "fa fa-spinner fa-spin"
                                }, () => {
                                    let datos = { valorTe, valorMa, periodoSelect, nota, notaSelect }
                                    AddNotaApl (datos, this.props.est.id, (resp) => {
                                        this.setState({
                                            boton1: "fa fa-save",
                                        }, () => {
                                            toast[resp[1]](resp[0],{autoClose: 4000});
                                            this.updateList(resp[1]);
                                        })
                                    })
                                })
                            }
                        }><i className={boton1}></i></button>
                    </Col>
                </Row>
                <div className="custom-mt-10" style={{overflowY:"auto", height:"50vh", overflowX:"hidden"}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="10%" style={styles}><strong>CÓDIGO</strong></td>
                                    <td width="35%" style={styles}><strong>MATERIA</strong></td>
                                    <td align="center" width="15%" style={styles}><strong>PERIODO</strong></td>
                                    <td align="center" width="20%" style={styles}><strong>T-E</strong></td>
                                    <td align="center" width="10%" style={styles}><strong>NOTA</strong></td>
                                    <td align="center" width="10%" style={styles}><strong>LETRAS</strong></td>
                                    <td width={100} style={styles}><strong>ACCIONES</strong></td>
                                </tr>
                                {this.materias()}
                            </tbody>
                        </Table>
                    </div>
                </div>
                {this.modalDelMat()}
            </div>
        );
    }
}
 
export default EditHistoricoAddMat;


// WEBPACK FOOTER //
// ./src/views/Registros/HistoricoContent/EditHistoricoAddMat.jsx